import { ListItem, Typography, } from "@mui/material";
import { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import { InsertDriveFile as File, Folder } from '@mui/icons-material'

export interface FileItemProps {

    file?: any;

    selected?: boolean;
    
    isDirectory?: boolean;

    onDoubleClick?: (e: any) => void;
    onItemClick?: (e: any) => void;

    onUpload?: (files: any[]) => void;
}

export const FileItem : React.FC<FileItemProps> = (props) => {

    const onDrop = useCallback((file) => {
        props.onUpload?.(file)
    }, [])

    const { getRootProps, isDragActive, getInputProps } = useDropzone({
        noDragEventsBubbling: true,
        noClick: true,
        onDrop
    })

    return (
        <ListItem 
            {...(props.isDirectory ? getRootProps() : {})}
            sx={{
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': {
                    background: '#dfdfdf'
                },
                background: props.selected ? '#efefef' : undefined,
                display: 'flex',
                border: isDragActive ? '1px solid blue' : undefined,
                borderRadius: '5px',
            }}
            onDoubleClick={props.onDoubleClick}
            onClick={props.onItemClick}>
            {props.isDirectory && <input {...getInputProps()} />}
            {(props.isDirectory) ? <Folder /> : <File />}
            <Typography sx={{ marginLeft: '8px' }}>{props.file?.name}</Typography>
        </ListItem>
    )
}